<template>
    <div class="tile">
        <div class="tile-content">
            <v-select
                label="Select currencies"
                placeholder="Select currencies"
                :options="currenciesList"
                :multiple="true"
                :value="value"
                @input="updateSelected"/>
        </div>
    </div>
</template>
<script>
    import {vSelect} from '@/components/form';
    import {CURRENCIES_LIST} from '@/data/currencies';

    export default {
        name: 'currency-selection',
        components: {vSelect},
        props: {
            value: {
                type: Array,
            },
        },
        data() {
            return {
                currenciesList: [...CURRENCIES_LIST],
            };
        },
        methods: {
            updateSelected(currencies) {
                this.$emit('input', currencies);
            },
        },
    };
</script>
